export default {
	init: () => {
		import( /* webpackChunkName: "plugins/am2-Tabs" */ "./../../plugins/am2-Tabs").then(() => {
			const { Tabs } = am2;
			Tabs.init(document.querySelectorAll('[data-plugin-tabs]'));
		});
	},
};